export default __webpack_public_path__ + "static/media/warning.581c46c0.svg";